// extracted by mini-css-extract-plugin
export default {"root":"Skeleton_root__OaNxj","card":"Skeleton_card__6D3Sq","media":"Skeleton_media__azHa9"};